import * as yup from 'yup';

import { regex, formUtils } from '../../../../shared/utils';

const { field, sectionTitle, toArrayOfOptions } = formUtils;

const formSchema = (options, t, values) => [
  sectionTitle('instanceConfigurationSectionTitle', t),
  [
    {
      span: 24,
      columns: [
        field('select', 'dhisVersion', t, values, {
          required: true,
          placeholder: t('dhisVersion.placeholder'),
          options: toArrayOfOptions(options.dhisVersion).reverse()
        })
      ]
    }
  ],
  [
    {
      span: 24,
      columns: [
        field('select', 'instancePurpose', t, values, {
          required: true,
          options: toArrayOfOptions(options.instancePurpose)
        })
      ]
    }
  ],
  [
    {
      span: 24,
      columns: [
        field('select', 'urlType', t, values, {
          required: true,
          options: toArrayOfOptions(options.urlType)
        })
      ]
    }
  ],
  [
    {
      span: 24,
      columns: [
        field(
          'input',
          'url',
          t,
          values,
          {
            required: true
          },
          false,
          values['urlType'] === 'customerDomain'
        )
      ]
    }
  ],
  sectionTitle('regionsSectionTitle', t),
  [
    {
      span: 8,
      columns: [
        field('checkbox', 'regions.northAmerica', t, values),
        field('checkbox', 'regions.centralAsia', t, values),
        field('checkbox', 'regions.africa', t, values)
      ]
    },
    {
      span: 8,
      columns: [
        field('checkbox', 'regions.southAmerica', t, values),
        field('checkbox', 'regions.eastAsia', t, values),
        field('checkbox', 'regions.australia', t, values)
      ]
    },
    {
      span: 8,
      columns: [
        field('checkbox', 'regions.europe', t, values),
        field('checkbox', 'regions.westernAsia', t, values),
        field('checkbox', 'regions.norway', t, values)
      ]
    }
  ],
  sectionTitle('hostingInfoSectionTitle', t),
  [
    {
      span: 24,
      columns: [
        field('select', 'hostingPlan', t, values, {
          required: true,
          DEFAULT_VALUE_SUMMARY: '1',
          options: toArrayOfOptions(options.hostingPlan)
        })
      ]
    }
  ]
];

const preSetupFormSchema = (options, t, values) => [
  [
    {
      span: 24,
      columns: [
        field('select', 'servicePeriod', t, values, {
          required: true,
          options: toArrayOfOptions(options.servicePeriod)
        })
      ]
    }
  ],
  [
    {
      span: 24,
      columns: [field('checkbox', 'automaticallyRenew', t, values)]
    }
  ],
  [
    {
      span: 24,
      columns: [
        field('datepicker', 'instanceLaunchDate', t, values, {
          required: false,
          datesDisabled: 'beforeToday',
          mask: 'date',
          rightLabel: t('instanceLaunchDate.rightlabel')
        })
      ]
    }
  ]
];

const validationSchema = (t, values) => {
  const url =
    values['urlType'] === 'customerDomain'
      ? {
          url: yup
            .string()
            .matches(regex.url, t('url.error_invalid'))
            .required(t('url.error_required'))
        }
      : {};
  return yup.object().shape({
    dhisVersion: yup.string().required(t('dhisVersion.error_required')),
    instancePurpose: yup.string().required(t('instancePurpose.error_required')),
    urlType: yup.string().required(t('urlType.error_required')),
    ...url,
    hostingPlan: yup.string().required(t('hostingPlan.error_required'))
  });
};

const preSetupValidationSchema = (t, values) =>
  yup.object().shape({
    servicePeriod: yup.string().required(t('servicePeriod.error_required'))
  });

export {
  formSchema,
  validationSchema,
  preSetupValidationSchema,
  preSetupFormSchema
};
